import { appFeature } from 'modules/organizer/domain/interfaces/available-feature';

export function featureKeys(features: { feature: appFeature }[]): appFeature[] {
  return features.map((item) => item.feature);
}

export function sameFeatureSet(left: appFeature[], right: appFeature[]): boolean {
  if (left.length !== right.length) {
    return false;
  }

  const rightSet = new Set(right);
  return left.every((feature) => rightSet.has(feature));
}

export function diffPlanFeatures(
  current: appFeature[],
  next: appFeature[],
): { add: appFeature[]; remove: appFeature[] } {
  const currentSet = new Set(current);
  const nextSet = new Set(next);

  return {
    add: next.filter((feature) => !currentSet.has(feature)),
    remove: current.filter((feature) => !nextSet.has(feature)),
  };
}
